import { render } from "./MngInventory2.vue?vue&type=template&id=497f4715&ts=true"
import script from "./MngInventory2.vue?vue&type=script&lang=ts"
export * from "./MngInventory2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__